import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import OptimizedImage from './OptimizedImage';
import { useLeadModal } from '../context/LeadModalContext';

export default function MainNav() {
  const { pathname } = useLocation();
  const isHome = pathname === '/';
  const [navScrolled, setNavScrolled] = useState(!isHome);
  const { openModal } = useLeadModal();

  useEffect(() => {
    if (!isHome) {
      setNavScrolled(true);
      return;
    }
    const handleScroll = () => setNavScrolled(window.scrollY > 40);
    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isHome]);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const logoBlack = `${process.env.PUBLIC_URL}/black.png`;
  const logoWhite = `${process.env.PUBLIC_URL}/white.png`;
  const logoSrc = navScrolled ? logoBlack : logoWhite;

  return (
    <header className={`nav ${navScrolled ? 'nav-scrolled' : 'nav-top'}`}>
      {isHome ? (
        <button type="button" className="nav-brand" onClick={() => scrollTo('hero')} aria-label="Notrack - back to top">
          <OptimizedImage
            src={logoSrc}
            alt="Notrack logo — weight loss app India, no calorie tracking"
            className="nav-logo-img"
            width={320}
            height={80}
            loading="eager"
            decoding="async"
            fetchPriority="high"
          />
        </button>
      ) : (
        <Link className="nav-brand" to="/" aria-label="Notrack home">
          <OptimizedImage
            src={logoBlack}
            alt="Notrack logo — simple Indian diet plan without calorie counting"
            className="nav-logo-img"
            width={320}
            height={80}
            loading="eager"
            decoding="async"
            fetchPriority="high"
          />
        </Link>
      )}

      <div className="nav-right">
        <nav className="nav-links" aria-label="Primary">
          {isHome ? (
            <>
              <button type="button" className="nav-link" onClick={() => scrollTo('how')}>
                How it works
              </button>
              <button type="button" className="nav-link" onClick={() => scrollTo('pricing')}>
                Pricing
              </button>
              <button type="button" className="nav-link" onClick={() => scrollTo('blog')}>
                Blog
              </button>
              <button type="button" className="nav-link" onClick={() => scrollTo('faq')}>
                FAQ
              </button>
              <Link className="nav-link" to="/about">
                About
              </Link>
              <Link className="nav-link" to="/contact">
                Contact
              </Link>
            </>
          ) : (
            <>
              <Link className="nav-link" to="/#how">
                How it works
              </Link>
              <Link className="nav-link" to="/#pricing">
                Pricing
              </Link>
              <Link className="nav-link" to="/blog">
                Blog
              </Link>
              <Link className="nav-link" to="/#faq">
                FAQ
              </Link>
              <Link className="nav-link" to="/about">
                About
              </Link>
              <Link className="nav-link" to="/contact">
                Contact
              </Link>
            </>
          )}
        </nav>
        <button type="button" className="nav-cta" onClick={() => openModal('Founding Plan')}>
          Lock Early Access
        </button>
      </div>
    </header>
  );
}
